module.exports = __webpack_public_path__ + "img/thumb_16.c617049e.jpg";